import { memoizedCatalogData } from 'bundles/catalogP/api/api.promise';
import catalogUrl from 'bundles/catalogP/lib/catalogUrl';
import SpecializationMemberships from 'bundles/catalogP/models/specializationMemberships';

export default function (options: $TSFixMe) {
  return memoizedCatalogData(catalogUrl.build(SpecializationMemberships.prototype.resourceName, options || {}));
}
